import React from "react";
import { Card, Button, Row, Col, Typography } from "antd";
import { UserOutlined, TeamOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../utils/routes";

const { Title, Paragraph } = Typography;

export default function AuthHomePage() {
  const navigate = useNavigate();
  const cardStyle = {
    width: "100%",
    height: "350px",
    margin: "20px 0",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  };

  const iconStyle = {
    fontSize: "48px",
    margin: "20px 0 10px",
  };

  const buttonStyle = {
    margin: "0 10px 20px",
  };

  return (
    <div
      style={{
        paddingLeft: 20,
        paddingRight: 20,
        background: "#f0f2f5",
        minHeight: "100vh",
      }}>
      <Row
        gutter={[16, 16]}
        justify="center"
        align="middle"
        style={{ minHeight: "100vh" }}>
        <Col xs={24} sm={20} md={12} lg={10} xl={8}>
          <Card style={cardStyle} hoverable>
            <div>
              <UserOutlined style={iconStyle} />
              <Title level={2}>Firma Girişi</Title>
              <Paragraph type="secondary">
                Personel arıyorsanız giriş yapın veya yeni hesap oluşturun
              </Paragraph>
            </div>
            <div>
              <Button
                onClick={() => {
                  navigate(PageRoutes.loginFirm);
                }}
                type="primary"
                style={buttonStyle}>
                Giriş Yap
              </Button>
              <Button
                onClick={() => {
                  navigate(PageRoutes.signupFirm);
                }}
                style={buttonStyle}>
                Üye Ol
              </Button>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={20} md={12} lg={10} xl={8}>
          <Card style={cardStyle} hoverable>
            <div>
              <TeamOutlined style={iconStyle} />
              <Title level={2}>Personel Girişi</Title>
              <Paragraph type="secondary">
                İş arıyorsanız giriş yapın veya yeni hesap oluşturun
              </Paragraph>
            </div>
            <div>
              <Button
                onClick={() => {
                  navigate(PageRoutes.loginWorker);
                }}
                type="primary"
                style={buttonStyle}>
                Giriş Yap
              </Button>
              <Button
                onClick={() => {
                  navigate(PageRoutes.signupWorker);
                }}
                style={buttonStyle}>
                Üye Ol
              </Button>
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
